import deleteCompany from './deleteCompany'
import deleteDevice from './deleteDevice'
import deletePromotion from './deletePromotion'
import getAdminCompanies from './getAdminCompanies'
import getAllCompanies from './getAllCompanies'
import getAdminDevices from './getAdminDevices'
import getAllDevices from './getAllDevices'
import getAdminPromotions from './getAdminPromotions'
import getOrganizationAdmins from './getOrganizationAdmins'

const actions = {
  deleteCompany,
  deleteDevice,
  deletePromotion,
  getAdminCompanies,
  getAllCompanies,
  getAdminDevices,
  getAllDevices,
  getAdminPromotions,
  getOrganizationAdmins
}

export default actions
